import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './OrderConfirmation';

const OrderConfirmationSuspense = dynamic(() => import('./OrderConfirmation'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicOrderConfirmation(props: Props) {
	return <OrderConfirmationSuspense {...props} />;
}
DynamicOrderConfirmation.displayName = 'DynamicOrderConfirmation';
